import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../constants/common'
import { PAGE_SIZE_PARAM_KEY } from '../../constants/route'
import { useScreen } from '../../hooks'
import Button from '../Button'
import {
  TableModal,
  TableModalButtonExport,
  useTableModalLoadingData,
} from '../TableModal'

import { QA_NAME_REPORT_TABLE } from './ReportTableModal.constants'
import { useReportTableExport } from './ReportTableModal.hooks'
import { ReportTableModalRow } from './ReportTableModalRow'
import { ReportTableModalTabBar } from './ReportTableModalTabBar'

function ReportTableModal({
  TableRow = ReportTableModalRow,
  buttonCancelProps,
  counterTextKey,
  emptyStateTextKey = 'Modal.ReportsTableNoDataKey',
  entityId,
  headerTextKey = 'Modal.ReportsModalTitleKey',
  initialTab,
  paginationPageSizeKey = PAGE_SIZE_PARAM_KEY,
  qaName = QA_NAME_REPORT_TABLE,
  tabs,
  onClose,
}) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  const [activeTab, setActiveTab] = useState(initialTab ?? tabs[0].id)

  const activeConfig = tabs.find(tab => tab.id === activeTab) ?? tabs[0]

  const tabBarItems = tabs.map(({ id, text }) => ({ id, text }))

  const {
    handleChangePagination,
    handleSetOrdering,
    loading,
    ordering,
    pagination,
    tableItems,
  } = useTableModalLoadingData({
    entityId,
    getItemsFromResponse: activeConfig.getItemsFromResponse,
    getRequestParams: activeConfig.getRequestParams,
    loadItems: activeConfig.loadItems,
    paginationPageSizeKey,
  })

  const { handleClickExport, modal } = useReportTableExport({
    entityId,
    onCheckTask: activeConfig.onCheckExportTask,
    onStartExport: activeConfig.onStartExport,
  })

  const hasExport = Boolean(activeConfig.onStartExport)

  const hasTabs = tabs.length > 1

  return (
    <>
      <TableModal
        Search={null}
        SelectionToolbar={null}
        TableTabBar={hasTabs ? ReportTableModalTabBar : null}
        actionsProps={{
          ButtonAttach: null,
          ButtonExport: hasExport ? TableModalButtonExport : null,
          buttonCancelProps: {
            Component: Button.Contained,
            onClick: onClose,
            ...buttonCancelProps,
          },
          ...(hasExport
            ? { buttonExportProps: { onClick: handleClickExport } }
            : null),
        }}
        counterProps={
          counterTextKey
            ? { count: pagination.count, text: counterTextKey }
            : null
        }
        emptyStateProps={{ text: t(emptyStateTextKey) }}
        headerProps={{ text: headerTextKey, onClose }}
        isFullScreenExist={!isMobileScreenSize}
        isMobileScreenSize={isMobileScreenSize}
        loading={loading}
        paginationProps={{ pagination, onChange: handleChangePagination }}
        qaName={qaName}
        selected={EMPTY_LIST}
        tableItems={tableItems?.items}
        tableProps={{
          TableRow,
          actionsColumnWidth: 0,
          columns: activeConfig.columns,
          headerRowProps: {
            ordering,
            resizable: false,
            withCellBorder: false,
            onSetOrdering: handleSetOrdering,
          },
          items: tableItems?.items,
        }}
        tableTabBarProps={{
          activeTab,
          tabs: tabBarItems,
          onSetActiveTab: setActiveTab,
        }}
        onTableModalClose={onClose}
      />
      {modal}
    </>
  )
}

export default ReportTableModal
